export default {
  'home.metaTitle': 'USFans Spreadsheet 2026 – Finds, Reviews, QC & Buying Guide',
  'home.metaDescription':
    'Explore the USFans Spreadsheet with product finds, QC guides, shipping information, reviews, safety tips, coupons and practical buying resources for 2026.',

  'home.navHome': 'Home',
  'home.navSpreadsheet': 'Spreadsheet',
  'home.navCategories': 'Categories',
  'home.navGuides': 'Guides',
  'home.navShoppingGuide': 'Shopping Guide',
  'home.navReviews': 'Reviews',
  'home.navShipping': 'Shipping',
  'home.navSafety': 'Safety',
  'home.navVisit': 'Visit Main Website',

  'home.heroBadge': 'USFans Spreadsheet Resource Hub',
  'home.heroTitle': 'Find Better Products with the USFans Spreadsheet',
  'home.heroSubtitle':
    'The USFans Spreadsheet makes product research easier by organizing useful finds, categories, QC resources, shipping guides, reviews and buying information in one searchable resource.',
  'home.heroSubtitle2':
    "Whether you're new to USFans or already know how the process works, start here to research products, compare options and understand the buying process before making a decision.",
  'home.heroTrust': 'Independent informational resource • Updated regularly • Beginner friendly',
  'home.ctaSpreadsheet': 'usfans spreadsheet',
  'home.ctaBuyNow': 'buy it now',
  'home.ctaGuide': 'Read the Beginner Guide',

  'home.catTitle': 'Explore USFans Spreadsheet Categories',
  'home.catSubtitle':
    'Browse organized categories and jump straight to the products you are looking for on the main website.',
  'home.catPlaceholder': 'Select a category',
  'home.catBrowseAll': 'Browse all categories',
  'home.catShoes': 'Shoes',
  'home.catHoodies': 'Hoodies / Sweaters',
  'home.catTshirts': 'T-Shirts',
  'home.catJackets': 'Jackets',
  'home.catPants': 'Pants / Shorts',
  'home.catHeadwear': 'Headwear',
  'home.catSets': 'Sets',
  'home.catUnderwear': 'Underwear / Underpants',
  'home.catJersey': 'Jersey',
  'home.catAccessories': 'Accessories',
  'home.catBags': 'Bags',
  'home.catBelts': 'Belts',
  'home.catPerfumes': 'Perfumes',
  'home.catOther': 'Other Stuff',

  'home.whatTitle': 'What Is the USFans Spreadsheet?',
  'home.whatP1':
    'The USFans Spreadsheet is a structured resource for discovering and researching product links, categories and shopping information associated with USFans.',
  'home.whatP2':
    'Instead of searching through scattered posts, you can explore organized categories, guides, reviews, QC information, shipping resources and frequently asked questions in one place.',
  'home.whatCta': 'Explore the Spreadsheet',

  'home.whyTitle': 'Why Use a USFans Spreadsheet?',
  'home.whySubtitle': 'A few reasons why the spreadsheet helps you shop more efficiently.',
  'home.why1Title': 'Research Faster',
  'home.why1Desc': 'Find relevant products and resources without searching through dozens of unrelated pages.',
  'home.why2Title': 'Compare Options',
  'home.why2Desc': 'Use structured information and comparison tables before making a decision.',
  'home.why3Title': 'Understand QC',
  'home.why3Desc': 'Learn what QC photos mean and what you should check before shipping.',
  'home.why4Title': 'Understand Shipping',
  'home.why4Desc': 'Learn how weight, destination, packaging and shipping methods can affect total costs.',

  'home.reviewTitle': 'USFans Review',
  'home.reviewP':
    'Thinking about using USFans? Read our independent USFans Review covering how the process works, advantages, limitations, QC, warehouse, shipping, safety and common problems.',
  'home.review1': 'How the process works',
  'home.review2': 'Advantages & limitations',
  'home.review3': 'QC & warehouse',
  'home.review4': 'Shipping',
  'home.review5': 'Safety & user considerations',
  'home.review6': 'Common problems',
  'home.reviewCta': 'Read USFans Review',

  'home.shipTitle': 'USFans Shipping Cost',
  'home.shipP':
    'Shipping can significantly affect the final cost of an order. Learn how shipping cost can vary according to different factors.',
  'home.ship1': 'Destination',
  'home.ship2': 'Parcel weight & volume',
  'home.ship3': 'Shipping line & packaging',
  'home.ship4': 'Insurance & seasonal changes',
  'home.shipNote': 'Prices vary — check current rates and estimate before checkout.',
  'home.shipCta': 'View Shipping Cost Guide',

  'home.couponTitle': 'USFans Coupon & Discount Code',
  'home.couponP':
    'A dedicated resource for USFans coupons, discount codes, promo codes and shipping coupons. Every coupon page shows status, last checked date, expiration, restrictions and how to apply.',
  'home.coupon1': 'Status & last checked',
  'home.coupon2': 'Expiration & restrictions',
  'home.coupon3': 'Source',
  'home.coupon4': 'How to apply',
  'home.couponNote': 'No verified active code found.',
  'home.couponCta': 'Check Current Coupons',

  'home.wareTitle': 'USFans Warehouse',
  'home.wareP':
    'Understand what the warehouse does: QC photos, storage, parcel consolidation, packaging, shipping preparation, inspection and potential storage limits.',
  'home.ware1': 'QC photos & inspection',
  'home.ware2': 'Storage',
  'home.ware3': 'Parcel consolidation',
  'home.ware4': 'Packaging & shipping preparation',
  'home.ware5': 'Potential storage limits',
  'home.wareCta': 'Read Warehouse Guide',

  'home.legitTitle': 'Is USFans Legit?',
  'home.legitP':
    'Get a direct answer to the search intent. Understand what USFans is, how the buying workflow works, and what risks and checks you should be aware of before payment.',
  'home.legit1': 'What USFans is (and is not)',
  'home.legit2': 'How the buying workflow works',
  'home.legit3': 'What risks to understand',
  'home.legit4': 'How to verify information',
  'home.legit5': 'What to check before payment',
  'home.legitNote': 'No unsupported claims — read the facts before you decide.',
  'home.legitCta': 'Read the Legit Guide',

  'home.compTitle': 'USFans Spreadsheet Comparison',
  'home.compHeader1': 'Resource',
  'home.compHeader2': 'Main Purpose',
  'home.compHeader3': 'Best For',
  'home.compHeader4': 'QC Info',
  'home.compHeader5': 'Shipping Info',
  'home.compHeader6': 'Beginner Friendly',
  'home.compRow1c1': 'Spreadsheet',
  'home.compRow1c2': 'Product Research',
  'home.compRow1c3': 'Finding Products',
  'home.compRow1c4': 'Varies',
  'home.compRow1c5': 'Guide',
  'home.compRow1c6': 'Yes',
  'home.compRow2c1': 'Review',
  'home.compRow2c2': 'Platform Research',
  'home.compRow2c3': 'Evaluation',
  'home.compRow2c4': 'Yes',
  'home.compRow2c5': 'Yes',
  'home.compRow2c6': 'Yes',
  'home.compRow3c1': 'QC Guide',
  'home.compRow3c2': 'Quality Research',
  'home.compRow3c3': 'QC',
  'home.compRow3c4': 'Yes',
  'home.compRow3c5': 'Limited',
  'home.compRow3c6': 'Yes',
  'home.compRow4c1': 'Shipping Guide',
  'home.compRow4c2': 'Delivery Research',
  'home.compRow4c3': 'Shipping',
  'home.compRow4c4': 'No',
  'home.compRow4c5': 'Yes',
  'home.compRow4c6': 'Yes',

  'home.guidesTitle': 'Latest USFans Guides',
  'home.guidesSubtitle': 'Fresh, original guides to help you research and buy with confidence.',
  'home.guidesRead': 'Read Article',
  'home.guidesUpdated': 'Updated',

  'home.faqTitle': 'Frequently Asked Questions',
  'home.faqQ1': 'What is the USFans Spreadsheet?',
  'home.faqA1':
    'It is an organized resource that brings product links, categories and shopping information together in one searchable place for product research.',
  'home.faqQ2': 'Is USFans legit?',
  'home.faqA2':
    'USFans is a research and buying workflow. Always verify links, check seller information and understand the risks before making any payment.',
  'home.faqQ3': 'How much does USFans shipping cost?',
  'home.faqA3':
    'Shipping varies by destination, weight, volume, line, packaging and season. Check current rates before checkout.',
  'home.faqQ4': 'Are there active USFans coupon codes?',
  'home.faqA4':
    'Codes change often. If no verified active code is available, treat the regular price as your baseline.',
  'home.faqQ5': 'What should I check before buying?',
  'home.faqA5':
    'Review QC photos, estimate shipping, confirm seller details, check return policies and keep records of your order.',

  'home.finalTitle': 'Ready to Explore?',
  'home.finalSubtitle':
    'Start with the USFans Spreadsheet, then use our guides to research products, understand QC and compare shipping options.',
  'home.finalCta': 'Explore USFans Spreadsheet',

  'home.footerDesc':
    'An independent informational resource about the USFans Spreadsheet. Not affiliated with or endorsed by USFans unless explicitly stated.',
  'home.footerResources': 'Resources',
  'home.footerSpreadsheet': 'USFans Spreadsheet',
  'home.footerGuides': 'Guides',
  'home.footerReviews': 'Reviews',
  'home.footerShipping': 'Shipping',
  'home.footerCoupons': 'Coupons',
  'home.footerWarehouse': 'Warehouse',
  'home.footerQC': 'QC',
  'home.footerSafety': 'Safety',
  'home.footerFaq': 'FAQ',
  'home.footerCompany': 'Company',
  'home.footerAbout': 'About',
  'home.footerContact': 'Contact',
  'home.footerEditorial': 'Editorial Policy',
  'home.footerPrivacy': 'Privacy Policy',
  'home.footerTerms': 'Terms',
  'home.footerDisclaimer': 'Disclaimer',
  'home.footerLanguages': 'Languages',
  'home.footerRights': 'All rights reserved.',
};